module.exports = __webpack_public_path__ + "static/media/website development icon.f1d164b0.svg";